import { createAsyncThunk } from '@reduxjs/toolkit'
import { CreationData, sampleCreations } from 'Vendor/Utils/TestData'
import { RootState } from '../store'
import { StudioState } from './initialState'
import Api from 'Vendor/Api'

export const fetchCreation = createAsyncThunk(
    'studio/fetchCreation',
    async (creationId: number) => {
        return new Promise<CreationData>((resolve) => {
            setTimeout(() => {
                const data = sampleCreations[creationId]
                if (data) {
                    resolve(data)
                } else {
                    resolve({ id: creationId, items: [] })
                }
            }, 300)
        })
    },
)

export const saveCreation = createAsyncThunk<
    { success: boolean },
    void,
    { state: RootState }
>('studio/saveCreation', async (_, { getState }) => {
    const state = getState().studio.present

    if (!state.creationId) {
        throw new Error('No creation ID is set.')
    }

    if (getState().studio.past.length === 0) {
        return { success: true }
    }

    const designData: StudioState = state

    const response = await Api.patch(
        `/studio/creation/${state.creationId}/data`,
        designData,
    )

    return response.data
})
